import { useHookstate } from "@hookstate/core";
import {
    UPDATED_CAR_DATA_STATE,
    MAP_GLOBAL_STATES,
    GLOBAL_SITE_SEARCH,
} from "globalStore/globalStore";
import { useEffect } from "react";
import { isCarInUse } from "../_helperFunctions/isCarInUse";
import { carType, carConnectionType, paceStatus, batteryLevel } from "constant";
import { showEnergySaverIcon } from "_helperFunctions/showEnergySaverIcon";

export const useFilteredCarsHook = ({
    marshalCars,
    specialCars,
    memberCars,
    memberSpecialCars,
    beverageCars,
    fleetCars,
    notCommunicatingCars,
    notInUseCars,
    paceWarning,
    paceCritical,
    batteryWarning,
    batteryCritical,
    carsInEnergySaverMode,
    carLocationBtn = false,
}) => {
    const { updatedCarData: updatedCarDataState } = useHookstate(UPDATED_CAR_DATA_STATE);
    const { isFirstUpdate } = useHookstate(GLOBAL_SITE_SEARCH);
    const { getSelectedCarsState } = useHookstate(MAP_GLOBAL_STATES);

    const isFirstUpdateValue = isFirstUpdate.get();
    const updatedCarDataValue = updatedCarDataState.get();

    useEffect(() => {
        if (!isFirstUpdateValue) {
            if (marshalCars &&
                specialCars &&
                memberCars &&
                memberSpecialCars &&
                beverageCars &&
                fleetCars &&
                notCommunicatingCars &&
                notInUseCars &&
                carsInEnergySaverMode
            ) {
                if (updatedCarDataValue && updatedCarDataValue.length !== 0) {
                    let allCars = JSON.parse(updatedCarDataValue && updatedCarDataValue);
                    let tempArray = [];
                    let batteryAndPace = [];

                    if (allCars && allCars?.length !== 0) {
                        for (let i = 0; i < allCars.length; i++) {
                            let carTypeHasExplicitFilter =
                                allCars[i]?.Car?.CarType === carType?.marshal ||
                                allCars[i]?.Car?.CarType === carType?.handicap ||
                                allCars[i]?.Car?.CarType === carType?.member ||
                                allCars[i]?.Car?.CarType === carType?.bevcart;

                            if (carsInEnergySaverMode && showEnergySaverIcon(allCars[i]?.Car)) {
                                // Energy Saver is independent of every other filter
                                tempArray.push(allCars[i]);
                            } else if (!carsInEnergySaverMode && showEnergySaverIcon(allCars[i]?.Car)) {
                                // Energy Saver is disabled, do NOT add this car
                                continue;
                            } else if (notCommunicatingCars) {
                                if ((marshalCars && allCars[i]?.Car?.CarType === carType?.marshal) ||
                                    (specialCars && allCars[i]?.Car?.CarType === carType?.handicap) ||
                                    (memberCars && allCars[i]?.Car?.CarType === carType?.member && allCars[i]?.Car?.SecondaryCarType === 0) ||
                                    (memberSpecialCars && allCars[i]?.Car?.CarType === carType?.member && allCars[i]?.Car?.SecondaryCarType === carType?.handicap) ||
                                    (beverageCars && allCars[i]?.Car?.CarType === carType?.bevcart) ||
                                    (fleetCars && isCarInUse(allCars[i]?.Car) && !carTypeHasExplicitFilter) ||
                                    (notCommunicatingCars && allCars[i]?.Car?.Connection === carConnectionType?.notCommunicatingCarEnabled) ||
                                    (notInUseCars && !isCarInUse(allCars[i]?.Car))) {
                                    tempArray.push(allCars[i]);
                                }
                            } else if (!notCommunicatingCars && allCars[i]?.Car?.Connection !== carConnectionType?.notCommunicatingCarEnabled) {
                                if ((marshalCars && allCars[i]?.Car?.CarType === carType?.marshal) ||
                                    (specialCars && allCars[i]?.Car?.CarType === carType?.handicap) ||
                                    (memberCars && allCars[i]?.Car?.CarType === carType?.member && allCars[i]?.Car?.SecondaryCarType === 0) ||
                                    (memberSpecialCars && allCars[i]?.Car?.CarType === carType?.member && allCars[i]?.Car?.SecondaryCarType === carType?.handicap) ||
                                    (beverageCars && allCars[i]?.Car?.CarType === carType?.bevcart) ||
                                    (fleetCars && isCarInUse(allCars[i]?.Car) && !carTypeHasExplicitFilter) ||
                                    (notInUseCars && !isCarInUse(allCars[i]?.Car))) {
                                    tempArray.push(allCars[i]);
                                }
                            }
                        }

                        if (tempArray && tempArray.length !== 0) {
                            for (var i = 0; i < tempArray.length; i++) {
                                if (paceWarning || paceCritical || batteryWarning || batteryCritical) {
                                    if ((paceWarning && tempArray[i]?.Car?.PaceStatus === paceStatus.warning) ||
                                        (paceCritical && tempArray[i]?.Car?.PaceStatus === paceStatus.critical) ||
                                        (batteryWarning &&
                                            tempArray[i]?.Car?.BatteryLevel > batteryLevel.critical &&
                                            tempArray[i]?.Car?.BatteryLevel <= batteryLevel.warning &&
                                            !tempArray[i]?.Car?.IsCharging) ||
                                        (batteryCritical &&
                                            tempArray[i]?.Car?.BatteryLevel <= batteryLevel.critical &&
                                            !tempArray[i]?.Car?.IsCharging)) {
                                        batteryAndPace.push(tempArray[i]);
                                    }
                                } else {
                                    batteryAndPace.push(tempArray[i]);
                                }
                            }
                        }
                        getSelectedCarsState.set([...batteryAndPace]);
                    }
                }
            } else if (marshalCars ||
                specialCars ||
                memberCars ||
                memberSpecialCars ||
                beverageCars ||
                fleetCars ||
                notCommunicatingCars ||
                notInUseCars ||
                paceWarning ||
                paceCritical ||
                batteryWarning ||
                batteryCritical ||
                carsInEnergySaverMode) {
                if (updatedCarDataValue && updatedCarDataValue.length !== 0) {
                    let allCars = JSON.parse(updatedCarDataValue && updatedCarDataValue);
                    let tempArray = [];
                    let batteryAndPace = [];
                    if (allCars && allCars?.length !== 0) {
                        for (let i = 0; i < allCars.length; i++) {
                            let carTypeHasExplicitFilter =
                                allCars[i]?.Car?.CarType === carType?.marshal ||
                                allCars[i]?.Car?.CarType === carType?.handicap ||
                                allCars[i]?.Car?.CarType === carType?.member && allCars[i]?.Car?.SecondaryCarType === 0 ||
                                allCars[i]?.Car?.CarType === carType?.bevcart;
                            if (carsInEnergySaverMode && showEnergySaverIcon(allCars[i]?.Car)) {
                                // Energy Saver is independent of every other filter
                                tempArray.push(allCars[i]);
                            } else if (!carsInEnergySaverMode && showEnergySaverIcon(allCars[i]?.Car)) {
                                // Energy Saver is disabled, do NOT add this car
                                continue;
                            } else if (notCommunicatingCars) {
                                if ((marshalCars && allCars[i]?.Car?.CarType === carType?.marshal) ||
                                    (specialCars && allCars[i]?.Car?.CarType === carType?.handicap) ||
                                    (memberCars && allCars[i]?.Car?.CarType === carType?.member && allCars[i]?.Car?.SecondaryCarType === 0) ||
                                    (memberSpecialCars && allCars[i]?.Car?.CarType === carType?.member && allCars[i]?.Car?.SecondaryCarType === carType?.handicap) ||
                                    (beverageCars && allCars[i]?.Car?.CarType === carType?.bevcart) ||
                                    (fleetCars && isCarInUse(allCars[i]?.Car) && !carTypeHasExplicitFilter) ||
                                    (notCommunicatingCars && allCars[i]?.Car?.Connection === carConnectionType?.notCommunicatingCarEnabled) ||
                                    (notInUseCars && !isCarInUse(allCars[i]?.Car))) {
                                    tempArray.push(allCars[i]);
                                }
                            } else if (!notCommunicatingCars && allCars[i]?.Car?.Connection !== carConnectionType?.notCommunicatingCarEnabled) {
                                if ((marshalCars && allCars[i]?.Car?.CarType === carType?.marshal) ||
                                    (specialCars && allCars[i]?.Car?.CarType === carType?.handicap) ||
                                    (memberCars && allCars[i]?.Car?.CarType === carType?.member && allCars[i]?.Car?.SecondaryCarType === 0) ||
                                    (memberSpecialCars && allCars[i]?.Car?.CarType === carType?.member && allCars[i]?.Car?.SecondaryCarType === carType?.handicap) ||
                                    (beverageCars && allCars[i]?.Car?.CarType === carType?.bevcart) ||
                                    (fleetCars && isCarInUse(allCars[i]?.Car) && !carTypeHasExplicitFilter) ||
                                    (notInUseCars && !isCarInUse(allCars[i]?.Car))) {
                                    tempArray.push(allCars[i]);
                                }
                            }
                        }

                        if (tempArray && tempArray.length !== 0) {
                            for (var i = 0; i < tempArray.length; i++) {
                                if (paceWarning || paceCritical || batteryWarning || batteryCritical) {
                                    if ((paceWarning && tempArray[i]?.Car?.PaceStatus === paceStatus.warning) ||
                                        (paceCritical && tempArray[i]?.Car?.PaceStatus === paceStatus.critical) ||
                                        (batteryWarning &&
                                            tempArray[i]?.Car?.BatteryLevel > batteryLevel.critical &&
                                            tempArray[i]?.Car?.BatteryLevel <= batteryLevel.warning &&
                                            !tempArray[i]?.Car?.IsCharging) ||
                                        (batteryCritical &&
                                            tempArray[i]?.Car?.BatteryLevel <= batteryLevel.critical &&
                                            !tempArray[i]?.Car?.IsCharging)) {
                                        batteryAndPace.push(tempArray[i]);
                                    }
                                } else {
                                    batteryAndPace.push(tempArray[i]);
                                }
                            }
                        }
                        const prev = getSelectedCarsState.get();
                        if (JSON.stringify(prev) !== JSON.stringify(batteryAndPace)) {
                            getSelectedCarsState.set([...batteryAndPace]);
                        }
                    }
                }
            } else {
                if (updatedCarDataValue && updatedCarDataValue.length !== 0) {
                    let allCars = JSON.parse(updatedCarDataValue && updatedCarDataValue);
                    let tempArray = [];
                    let batteryAndPace = [];
                    if (allCars && allCars?.length !== 0) {
                        for (let i = 0; i < allCars.length; i++) {
                            let carTypeHasExplicitFilter =
                                allCars[i]?.Car?.CarType === carType?.marshal ||
                                allCars[i]?.Car?.CarType === carType?.handicap ||
                                allCars[i]?.Car?.CarType === carType?.member ||
                                allCars[i]?.Car?.CarType === carType?.bevcart ||
                                allCars[i]?.Car?.CarType === carType?.member;

                            if (carsInEnergySaverMode && showEnergySaverIcon(allCars[i]?.Car)) {
                                // Energy Saver is independent of every other filter
                                tempArray.push(allCars[i]);
                            } else if (!carsInEnergySaverMode && showEnergySaverIcon(allCars[i]?.Car)) {
                                // Energy Saver is disabled, do NOT add this car
                                continue;
                            } else if (notCommunicatingCars) {
                                if ((marshalCars && allCars[i]?.Car?.CarType === carType?.marshal) ||
                                    (specialCars && allCars[i]?.Car?.CarType === carType?.handicap) ||
                                    (memberCars && allCars[i]?.Car?.CarType === carType?.member && allCars[i]?.Car?.SecondaryCarType === 0) ||
                                    (memberSpecialCars && allCars[i]?.Car?.CarType === carType?.member && allCars[i]?.Car?.SecondaryCarType === carType?.handicap) ||
                                    (beverageCars && allCars[i]?.Car?.CarType === carType?.bevcart) ||
                                    (fleetCars && isCarInUse(allCars[i]?.Car) && !carTypeHasExplicitFilter) ||
                                    (notCommunicatingCars && allCars[i]?.Car?.Connection === carConnectionType?.notCommunicatingCarEnabled) ||
                                    (notInUseCars && !isCarInUse(allCars[i]?.Car))) {
                                    tempArray.push(allCars[i]);
                                }
                            } else if (
                                !notCommunicatingCars && allCars[i]?.Car?.Connection !== carConnectionType?.notCommunicatingCarEnabled) {
                                if ((marshalCars && allCars[i]?.Car?.CarType === carType?.marshal) ||
                                    (specialCars && allCars[i]?.Car?.CarType === carType?.handicap) ||
                                    (memberCars && allCars[i]?.Car?.CarType === carType?.member && allCars[i]?.Car?.SecondaryCarType === 0) ||
                                    (memberSpecialCars && allCars[i]?.Car?.CarType === carType?.member && allCars[i]?.Car?.SecondaryCarType === carType?.handicap) ||
                                    (beverageCars && allCars[i]?.Car?.CarType === carType?.bevcart) ||
                                    (fleetCars && isCarInUse(allCars[i]?.Car) && !carTypeHasExplicitFilter) ||
                                    (notInUseCars && !isCarInUse(allCars[i]?.Car))) {
                                    tempArray.push(allCars[i]);
                                }
                            }
                        }

                        if (tempArray && tempArray.length !== 0) {
                            for (var i = 0; i < tempArray.length; i++) {
                                if (paceWarning || paceCritical || batteryWarning || batteryCritical) {
                                    if ((paceWarning && tempArray[i]?.Car?.PaceStatus === paceStatus.warning) ||
                                        (paceCritical && tempArray[i]?.Car?.PaceStatus === paceStatus.critical) ||
                                        (batteryWarning &&
                                            tempArray[i]?.Car?.BatteryLevel > batteryLevel.critical &&
                                            tempArray[i]?.Car?.BatteryLevel <= batteryLevel.warning &&
                                            !tempArray[i]?.Car?.IsCharging) ||
                                        (batteryCritical &&
                                            tempArray[i]?.Car?.BatteryLevel <= batteryLevel.critical &&
                                            !tempArray[i]?.Car?.IsCharging)
                                    ) {
                                        batteryAndPace.push(tempArray[i]);
                                    }
                                } else {
                                    batteryAndPace.push(tempArray[i]);
                                }
                            }
                        }
                        getSelectedCarsState.set([...batteryAndPace]);
                    }
                }
            }
        }
    }, [
        marshalCars,
        specialCars,
        memberCars,
        memberSpecialCars,
        beverageCars,
        fleetCars,
        notCommunicatingCars,
        notInUseCars,
        paceWarning,
        paceCritical,
        batteryWarning,
        batteryCritical,
        carLocationBtn,
        isFirstUpdateValue,
        carsInEnergySaverMode
    ]);

    useEffect(() => {
        let localCarData = !Array.isArray(updatedCarDataValue) && typeof updatedCarDataValue === "string" && JSON.parse(updatedCarDataValue);

        if (updatedCarDataValue && Array.isArray(localCarData) && localCarData.length !== 0) {
            if (isFirstUpdate.get()) {
                isFirstUpdate.set(false);
            }
        } else {
            getSelectedCarsState.set([]);
        }
    }, [updatedCarDataValue, isFirstUpdateValue]);

    return {
        getSelectedCarsState,
    };
};
